module.exports = __webpack_public_path__ + "static/img/AI审核_bj@2x.440d729b.png";